enum FormDataUrl {
  Tours = '/apiV1/destinationList/serp?slug=search',
  Hot = '/apiV1/destinationList/serp?slug=hot',
  Railway = '/apiV1/destinationList/serp?slug=railways_search',
  Hotels = '/apiV1/destinationList/serp?slug=hoteloffers_search',
}

enum IntelligentSearchUrl {
  Tours = '/intelligentSearch?slug=search',
  Hot = '/intelligentSearch?slug=hot',
  Railway = '/intelligentSearch?slug=railways_search',
  Hotels = '/intelligentSearch?slug=hoteloffers_search',
}

enum CountryResortsUrl {
  Tours = '/apiV1/resort/searchByCountry?slug=search',
  Hot = '/apiV1/resort/searchByCountry?slug=hot',
  Railway = '/apiV1/resort/searchByCountry?slug=railways_search',
  Hotels = '/apiV1/resort/searchByCountry?slug=hoteloffers_search',
}

export { FormDataUrl, IntelligentSearchUrl, CountryResortsUrl };
